import ru from './ru'
import en from './en'

export const messages = {
  ru: ru,
  en: en
}
